import React, { Component } from 'react'
import { connect } from 'react-redux'

const initialState = () => {
  return {
    receiverInput: { name: 'Robban AB', address1: '', phone: '',custom_name:'' },
    senderName: 'Testavsändare',
    packageId: `pkg-${Math.floor(Math.random() * 100000000)}`,
    deliveryId: '',
    carrierId: '',
    carrierName: 'Välj transportör',
    carrierInternalOrderId: Math.floor(Math.random() * 10000000)
  }
}

  class NewDelivery extends Component {
    constructor(p){
      super(p)
    }

    state = initialState()

    onInputChange = ({ target }) => this.setState({ [target.name]: target.value })

    onChangeName = (e) => {
      const { receiverInput } = this.state
      this.setState({
        receiverInput: { ...receiverInput, name: e.target.value },
      })
    }

    onChangeAddress = ({target:{value}}) => {
      if(value==="Välj enhet"){
      return this.setState({
        receiverInput: {
          address1:null
        }
      })
      }

      const lock = this.props.locks[value]

      this.setState({
        receiverInput: {
          ...this.state.receiverInput,
          address1:lock.address.street,
          custom_name:lock.custom_name,
          phone: null,
          displayName: null,
        },
      })
    }

   
    onChangeCarrier = (e) => {
      const { _id, organization } = JSON.parse(e.target.value)

      this.setState({
        carrierId: _id,
        carrierName: organization
      })
    }

    onChangePhone = (e) => {
      const customer = this.props.customers.find(c => c._id===e.target.value)

      if(!customer) return

      this.setState({
        receiverInput: {
          ...this.state.receiverInput,
          phone: customer.phone,
          displayName:`${customer.name} ${customer.surname}`
        },
      })
    }

    send = () => {
      const delivery = {
        sender: { name: this.state.senderName },
        receiver: this.state.receiverInput,
        delivery: { packageId: this.state.packageId ? this.state.packageId : `pkg${Math.floor(Math.random() * 100000000)}`, carrierInternalOrderId: this.state.carrierInternalOrderId },
        deliveryId: this.state.deliveryId,
        carrierId: this.state.carrierId,
        carrierName: this.state.carrierName        
      }

      this.props.addDelivery(delivery)

      this.setState({packageId:`pkg${Math.floor(Math.random() * 100000000)}`})
    }

    renderCustomerOptions = () => {
      const { receiverInput: { address1 }, receiverInput, } = this.state

      const selectedLock = this.props.locks.find((l) => l.address.street === address1)

      if (!selectedLock || !receiverInput.address1) {
        return [
          <option disabled key={'0'}>
            Välj en enhet först
        </option>,
        ]
      }

      const availableUsers = selectedLock.users.concat({ customer: selectedLock.owner })

      let mappedAvailableUsers = availableUsers
        .map((user) => {
          const customer = this.props.customers.find((c) => c._id === user.customer)
          if (!customer) return null

          return customer
        })
        .filter((v) => !!v)

      mappedAvailableUsers =  mappedAvailableUsers.map(({ phone, name, surname,_id }) => (
        <option key={phone} value={_id} checked={this.state.receiverInput.phone===phone}>
          {name ? `${name} ${surname}` : 'Inbjuden'}, {phone}
        </option>
      ))

      return mappedAvailableUsers
    }

    render() {
      const { carriers, locks } = this.props
      if (!carriers || !carriers.length) return <p>Inga transportörer?!</p>

      const { receiverInput: { address1, phone, name, custom_name }, senderName, packageId, deliveryId, carrierId,carrierName, carrierInternalOrderId } = this.state
      const disabled = !(name && senderName && carrierId)

      return (
        <div style={{ backgroundColor: 'white', border: '1px solid rgba(0,0,0,0.1)', overflow: 'hidden', padding: 20, }}>

          <input placeholder="Namn" type="text" value={senderName} onChange={(e) => this.setState({ senderName: e.target.value })} />

          &nbsp;
  
        <input type="text" placeholder={'Namn'} value={name} onChange={this.onChangeName} />

          &nbsp;
  
        <select onChange={this.onChangeAddress}>
            <option defaultChecked={this.state.receiverInput.address1.length<1}>Välj enhet</option>
            {locks &&
              locks.map(({ _id, address, custom_name },i) => (
                <option key={_id} value={i}>
                  {custom_name}, {address.street}
                </option>
              ))}
        </select>

          &nbsp;
  
        <select onChange={this.onChangePhone}>
            <option defaultChecked={this.state.receiverInput.phone===null}>Välj mottagare</option>
            {this.renderCustomerOptions()}
        </select>

          &nbsp;
  
          <input name="packageId" placeholder="PaketId" type="text" value={packageId} onChange={this.onInputChange} />

          &nbsp;
  
          <input name="deliveryId" placeholder="LeveransId" type="text" value={deliveryId} onChange={this.onInputChange} />

          &nbsp;

          <input name="carrierInternalOrderId" placeholder="carrierInternalOrderId" type="text" value={carrierInternalOrderId} onChange={this.onInputChange} />

          &nbsp;
  
          <select name="carrierId" value={carrierName} onChange={this.onChangeCarrier}>
            <option>{this.state.carrierName}</option>
            {this.props.carriers.map(({ _id, organization }) => (
              <option key={_id} value={JSON.stringify({_id,organization})}>
                {organization}
              </option>
            ))}
          </select>

          &nbsp;
  
        <button className="smallQbutton" style={{ float: 'none' }} disabled={disabled} onClick={this.send}>
            Spara
        </button>
        </div>
      )
    }
  }

  const mapProps = (state) => ({
    carriers: state.collectionData.carriers,
    locks: state.collectionData.locks.filter((l) => !l.isCarrierDoor),
    customers: state.collectionData.customers,
  })

  const mapDispatch = (dispatch) => ({

  })

  export default connect(mapProps, mapDispatch)(NewDelivery)